module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"patchAnnotationsButton.text":"Edit Annotation","patchAnnotationsButton.errorMessage":"There was an error encountered while updating this annotation. If anything does not look right please contact support so we can help you :)"}}')
  delete Component.options._Ctor
}
